// extracted by mini-css-extract-plugin
export default {"wrapperClass":"qagCB2Q8aRBvk4_od82w"};